/**
 * 健康管理工作站路由。
 *
 * 工作站分层 P4：仅落地站点壳 + 健康档案只读；风险评估/随访/干预等业务后续
 * 另立变更，不在此处预埋未实现接口。
 *
 * @module health-management/routes
 */
import type { RouteRecordRaw } from "vue-router";

const HealthManagementView = () =>
  import("./interfaces/HealthManagementView.vue");

export const healthManagementRoutes: RouteRecordRaw[] = [
  {
    path: "/health",
    name: "HealthManagement",
    component: HealthManagementView,
    meta: {
      title: "健康管理工作站",
      requiresAuth: true,
      keepAlive: false,
      breadcrumb: ["健康管理工作站"],
    },
  },
];

export default healthManagementRoutes;
